export default {
  titleBanner: { 
    subtitle: 'BLE | Bluetooth Low Energy',
    title: 'BLE位置測位およびポジショニング技術',
    description: '*BLEは、低電力消費量でデータ転送速度が低いワイヤレス通信技術の一つです。主に小型デバイスや低電力センサーで使用され、ビーコンなどの小型送信機としても活用されます。スマートホーム、スマートシティ、スマートファクトリー、IoT技術などでも利用されています。'
  },
  definition: {
    title: 'BLEとは何ですか？',
    text: 'Bluetooth Low Energy（以下BLE）は、ワイヤレス通信のための無線周波数（RF）技術であり、さまざまな屋内位置測位の目的に活用することができます。BLE技術を使用すると、人、デバイス、資産などの位置を検知し測位して、資産測位、屋内ナビゲーション、近接サービスなどさまざまな目的で活用することができます。Wi-FiやUWBなどの他の通信プロトコルと同様に、BLEもワイヤレスでデータを送受信するために使用されます。'
  },
  tech: {
    title: 'BLE技術の進化',
    text: 'BLE技術の成長は、グローバルなBluetoothエコシステムに根本的な変化をもたらしました。多くのBluetoothデバイスが屋内空間に進出し、現在世界中に80億以上のBluetoothデバイスが存在しています。新しいBluetooth互換のインフラストラクチャやツールは、革新的な位置検知機能を提供します。<br/><br/> 2013年、AppleのiBeaconが最初にリリースされた後、さまざまなBLE技術が登場しました。iBeaconは、物理的なビーコンが近くのワイヤレスデバイスと通信できるようにし、iOSやAndroidアプリケーションと連携して動作するように設計されました。2015年、Googleはオープンで相互運用性のあるビーコンプロトコルであるEddystoneを発表しました。これら2つの先進的なビーコンプロトコルと一緒に使用される多くの物理的ビーコン製品や位置測位センサーやタグなどの他のBLE技術は、人々やデバイスが屋内空間とやり取りする方法を変えました。<br/><br/> これらの技術と総合的なBluetooth通信プロトコルは、引き続き進化しています。2016年には、新しいBluetoothバージョンであるBluetooth 5.0が導入されました。BLE 4.0を基にしたこの新しいバージョンは、より高いデータ転送速度とより長い通信距離をサポートしています。2019年に公開されたBluetooth 5.1では、方向探知（direction finding, DF）によりより正確な位置検出が可能になり、センチメートルレベルの精度が期待されています。<br/><br/> BLEは、屋内位置測位のための最も人気のあるRF技術の一つであり、ワイヤレスデバイスで広く使用されています。低電力、低コスト、容易に実装可能なハードウェアオプションが多くあり、さまざまな位置ベースのアプリケーションで柔軟に使用することができる特徴を持っています。'
    },
  beacon: {
    title: 'BLEビーコンとは何ですか？',
    text: 'BLEビーコンは、小型で汎用性があり、低電力なBluetooth送信機であり、BLE対応のスマートフォンなどのワイヤレスデバイスで検知されることができます。ビーコンは壁や構造物に取り付けられるか、移動可能な資産に配置され、屋内位置測位アプリケーションに位置参照を提供します。これにより、誰もがスマートフォンや他の内蔵デバイスを使用してBLE対応のアプリケーションと対話できるBYOD（Bring Your Own Device）のコンセプトをサポートします。BLEビーコンは、文書、ビデオ、アプリなどの関連コンテンツを提供したり、ユーザーの時間や位置に関するガイダンスを提供したりして、ユーザーを案内および参加させます。<br/><br/> ビーコンは定期的な間隔で信号を送信し、他のBLE対応のデバイスによって検知されることができます。ビーコンで収集された位置データはBLEデバイスで収集され、インターネット位置システム（IPS）に送信されてデバイスの位置を決定します。これはさまざまな位置認識アプリケーションに使用され、屋内ナビゲーション、広告、位置ベースのサービスなどのさまざまな用途に応用されます。'
  },
  howItWorks: {
    title: 'Bluetoothポジショニングの仕組み',
    text: 'BLE（Bluetooth Low Energy）の屋内位置測位ソリューションは、BLE対応のセンサーやビーコンを使用して、屋内空間でスマートフォンやトラッキングタグなどのBluetoothデバイスを検出し、位置を特定します。センサーから収集された位置データやビーコンがモバイルデバイスに送信したデータは、さまざまな位置測位アプリケーションによって収集・分析され、これを基にさまざまな位置認識の使用例が実現されます。',
    items: [
      {
        title: 'ビーコンを使用したBLEポジショニング',
        description: 'BLEビーコンは、常にBLE信号を送信します。これらの信号は、スマートフォンやBLE対応のセンサーなど周囲のデバイスによって検出されます。ビーコンは屋内空間全体に固定された位置に配置されると、連続的に送信される信号にそのビーコンの固有の識別子が含まれます。この識別コードは定期的に他のデータと共にビーコン通信プロトコルに従って送信されます。 <br/><br/> 専用のアプリや事前に設定されたサービスをサポートするスマートフォンや他のワイヤレスデバイスは、ビーコンの範囲内にあるときに、ビーコンからの信号をユーザーセンタリックな方法で受信・分析したり、サーバーにこの情報を送信したりすることができます。1つのビーコンとデバイスの検出には、ビーコンとデバイスが互いに範囲内にあるかどうかを判断するプロキシベースの位置サービスを有効にすることができます。複数のビーコンが戦略的に配置された屋内空間全体でビーコンとワイヤレスデバイスの関係を利用してベクトルマップを抽出し、デバイスの位置を特定することができます。アプリケーションに応じて、デバイスの特定の位置は、特定のアクションをトリガーしたり、さまざまなアプリケーションやサービスで活用されることがあります。 <br/><br/> BLEビーコンはモバイルデバイスにも配置することができ、これはアセットトラッキングのシナリオで役立ちます。モバイルデバイス上に設置されたBLEビーコンは、固定されたBLE対応のセンサーで検出・位置を特定することができます。'
      },
      {
        title: 'センサーを使用したBLEポジショニング',
        description: 'BLEセンサーを使用した位置測位は、屋内空間に固定されたBLE対応のセンサーを活用します。これらのセンサーはBLEスマートフォン、アセットトラッキングタグ、ビーコン、スタッフバッジ、ウェアラブルデバイスなどのBluetoothデバイスから送信される信号強度を手動で検出し、位置を特定します。この位置データは、セントラルな屋内位置測位システム（IPS）やリアルタイム位置測位システム（RTLS）に送信されます。位置エンジンはこれらのデータを分析し、ベクトルマップを抽出し、送信デバイスの位置を決定します。これらの座標は、空間の屋内マップ上のデバイスやアセットの位置を可視化したり、特定の位置認識アプリケーションに応じて他の目的に使用されることがあります。'
      }
    ]
  },
  accuracy: {
    title: 'Bluetoothポジショニングの精度はどの程度ですか？',
    text: 'BLEの屋内位置測位およびリアルタイム位置システムは、システムアーキテクチャ、選択したハードウェア、配置されたセンサーやビーコンの密度によって、さまざまな精度レベルを提供することができます。BLEセンサーやビーコンを使用した屋内位置測位は、最適な条件と配置を考慮すれば、一般的に5メートル以下の位置精度を提供することができます。',
    text2: 'Wi-Fi技術と同様に、Bluetoothも一般にデバイスの信号強度（RSSI）を使用して位置を推定します。この位置決定方法は通常、メートル単位の位置精度を提供し、UWBなどの他の技術と比較してはるかに低い適合性を持っています。UWBはToF（Time of Flight）による距離ベースの測定技術を使用して、非常に正確なセンチメートルレベルの精度を提供します。BLEは現在、屋内位置測位において最も正確なRF技術ではありませんが、依然として非常に効果的で広く使用されている技術の一つです。多くの屋内位置測位シナリオでは、高い精度は必要ありませんので、BLEは柔軟性、低消費電力、低コスト、実装の容易さなど、多くのユニークな利点を提供する適切な選択肢です。 <br/><br/> Bluetooth 5.1のリリースと新しい方向決定機能により、BLEはサブメートルレベルの精度で位置を特定できるようになるでしょう。これは、Bluetooth信号の方向を計算するためのAngle of Arrival（AoA）を利用した新しい機能によるものです。この技術は、信号強度（RSSI）と組み合わせてデバイスやアセットの位置を測位し、向上した精度を提供します。方向を検出するために、単一アンテナを備えたモバイルアセット（タグやビーコンなど）が、複数のアンテナ配列を持つ固定BLEセンサーに送信されます。信号を受信した後、複数のアンテナの位相変化を測定して送信モバイルデバイスの到着角度を決定します。RSSIとAoAを組み合わせて、センチメートルレベルの精度でデバイスの座標を生成します。'
  },
  range: {
    title: 'BLEの通信範囲はどれくらいですか？',
    text: 'BLE位置測位技術の範囲は、BLEビーコンまたはBLE対応センサーを使用するか、屋内空間の特性などによって異なる場合があります。BLEは一般にUWBやWi-Fiなどの他のRF技術よりも短い範囲で動作し、最適な条件と配置では0〜25メートルの範囲で最も効果的に機能し、最大で100メートルまで動作することができます。'
  },
  difference: {
    title: 'BLEは他のRF技術とどのように異なりますか？',
    text: 'Bluetoothは他のワイヤレス標準技術と同様に、個々の要件、予算、施設、および特定の位置ベースの使用例に応じて、固有の特性と利点を提供します。BLEと他の技術の最も重要な違いは、低消費電力と多くの位置認識アプリケーションでの柔軟性です。BLEは屋内空間全体でデバイスに組み込まれており、多くの位置測位システムで利用され、産業やさまざまな使用例を含む屋内位置測位に拡張することができます。',
    items: [
      {
        title: 'BLE vs Wi-Fi',
        description: 'BLEとWi-Fiは、私たちの日常生活や屋内空間全体で最も一般的なRF技術の2つです。両方とも2.4GHzの周波数範囲で動作し、大規模なエコシステムと位置測位への確立された使用を含む多くの類似点があります。BLEとWi-Fiの両方はRSSIを使用して人々、デバイス、およびアセットの位置を検出します。ただし、BLEはより高い精度を達成するとされています。BLEははるかに少ない電力を要求し、より柔軟なハードウェアオプションとアプリケーションを可能にします。ただし、多くの組織はすでにWi-Fiインフラを保有しており、BLEの導入には新しいビーコン、センサーなどの統合が必要です。Wi-Fiはより長い範囲と高いデータ転送速度をサポートできますが、BLEはより制限された範囲です。'
        },
        {
        title: 'BLE vs UWB',
        description: 'BLEとUWBは、低消費電力、低コスト、アセット測位技術など、共通の特徴を持っています。ただし、UWBはBluetoothよりもはるかに優れた精度を提供することができます。これはUWBのToF（Time of Flight）に基づく正確な距離ベースの位置決定方法のためです。BLEは通常、デバイスの位置をRSSIに基づいて特定しますが、これはデバイスがビーコンやセンサーに比べて強いまたは弱い信号を送信しているかに応じてかなり低い精度を提供します。BLEはUWBよりもはるかに短い範囲とデータ転送速度を持っています。ただし、BluetoothはBLEビーコン、アセットタグ、センサーなどの柔軟なハードウェアオプションを通じて、多くの屋内空間に導入できる広く使用されるRF技術です。'
        }
    ]
  },
  advantage: {
    title: 'BLEの主な利点',
    items: {
      low: {
        title: '低消費電力、低コスト',
        description: 'BLEは低消費電力で低コストな技術であり、BLEセンサー、ビーコン、資産または人員タグなどで広く使用される理想的なRF技術です。'
      },
      distribute: {
        title: '展開が容易',
        description: 'BLEは展開が容易なソリューションを提供し、ネットワークに依存せず独立した柔軟なハードウェアオプションを提供するため、Bluetoothエコシステムに簡単に統合できます。'
      },
      tech: {
        title: '拡張可能な技術',
        description: 'この技術を活用して、資産測位、Bluetoothデバイス検出、屋内位置特定とナビゲーション、近接サービスなど、さまざまな位置認識の使用例を実現できます。'
      }
    }
  },
  useCase: {
    title: 'Bluetoothポジショニングの使用例',
    description: 'BLEの拡張性は、さまざまな屋内位置特定の使用例に効果的なオプションとなります。<br/>以下に、BLEの屋内位置特定技術が使用される一部の使用例やアプリケーション領域を示します。',
    card: {
      asset: {
        title: '資産測位',
        description: 'BLEは物理的な資産測位における主要なRF技術の1つとして機能します。多くの産業分野では、低消費電力、柔軟性、実装の容易性などの技術を活用して主要な資産や機器の位置と状態をリアルタイムで測位することができます。',
        items: [
          {
            name: '医療サービス',
            description: '主要な機器（例：換気設備や車椅子など）の位置を素早く特定して測位するために、資産測位機能を追加してください。'
            },
            {
            name: 'スマート製造',
            description: '設備、機械、およびリソースの位置と動きを把握し、可視化してください。'
            },
            {
            name: '倉庫管理',
            description: '大規模な施設内で、設備、ツール、および在庫の位置を特定するために、資産測位機能を統合してください。'
            }
        ]
      },
      employee: {
        title: '従業員および人物測位',
        description: '企業は柔軟なBLEビーコン、従業員タグ、およびセンサーを活用して、従業員や人材の位置を特定し、さまざまな位置ベースのアプリケーションを実装することができます。',
        items: [
          {
          name: 'ワイヤレスデバイスの検出',
          description: '政府や企業ビルなどのセキュリティに敏感な施設では、センサーを使用して屋内空間内のBLEおよび他のRFトランスミッターを検出できます。'
          },
          {
          name: 'ワークスペース最適化',
          description: '低コストのタグ（例：従業員バッジ、トラッキングステッカーなど）を活用して、スペースの利用と従業員の位置を特定して、効率性と生産性を向上させることができます。'
          },
          {
          name: '従業員の安全',
          description: '屋内空間をより安全にし、緊急事態や避難時に従業員を迅速に位置特定または通知できるようにします。'
          }
        ]
      },
      location: {
        title: '位置サービス',
        description: 'BLE（Bluetooth Low Energy）技術を利用した屋内位置測位システムを導入することで、組織や企業はスマートビルディングを構築することができます。これにより、建物内で人々の位置情報を把握し、さまざまな相互作用やメッセージ送信などの機能を提供することができます。',
        items: [
          {
          name: '近接メッセージ',
          description: 'BLEの屋内位置測位技術を導入して、顧客や資産の近くの目的地を特定し、そのデータを活用してクーポン、マーケティングキャンペーン、近隣観光地など、参加型の顧客エクスペリエンスを促進します。'
          },
          {
          name: 'ジオフェンシング',
          description: '屋内空間のさまざまな領域の周囲に仮想的な地理的境界を作成し、ユーザーが指定された領域に入ったり退出したり、滞在したりするときに特定のアクションを実行できるようにします。'
          }
        ]
      },
      navigation: {
        title: '屋内ナビゲーション',
        description: 'Bluetooth位置技術を活用した屋内ナビゲーションおよび案内機能により、空間を即座に親しみやすくし、探索することができます。',
        items: [
          {
          name: '屋内ナビゲーション',
          description: 'BLEの屋内位置ベースサービスを活用して、企業、医療、小売、ホテル、交通など、さまざまな産業の施設に優れた屋内体験を提供してください。'
          },
          {
          name: 'ブルードットウェイファインディング',
          description: 'BLEビーコンおよび他の屋内位置技術を使用して、企業、医療、小売、ホテル、交通など、さまざまな産業分野の施設で、ブルードット（Blue Dot）エクスペリエンスを通じた順番に従った案内やルート案内を実現できます。'
          }
        ]
      },
      business: {
        title: 'ビジネスインテリジェンス',
        description: 'BLEは価値ある位置データを収集し、強力な組織的洞察に変換するために活用できます。',
        items: [
          {
          name: '分析およびビジネスインテリジェンス',
          description: '資産、人員、およびデバイスの位置を特定し、測位し、時間の経過とともにこの位置データを分析できます。内部空間で訪問者が相互作用する方法を把握し、よりインテリジェントで情報化されたビジネスの意思決定を拡大するための視野を広げることができます。この作業にはBLEを活用できます。'
          }
        ]
      }
    }
  },
}